/**
 * Qui peut sortir de ses propres saisies.
 *
 * Deux droits distincts, et l'écart entre les deux est volontaire :
 * `direction` et `finance` consultent déjà les saisies de tous (c'est ce que
 * `listScopes.timeEntries` autorise côté kronos-api), mais seul `admin` en
 * modifie une qui ne lui appartient pas.
 *
 * Les rôles sont ceux du jeton Entra — `employee`, `admin`, `direction`,
 * `finance` — et eux seuls. Écrire `roles.includes('rd_manager')` produit un
 * sélecteur qui s'affiche et une requête qui 403 (cf. CLAUDE.md § Roles) ;
 * c'est exactement le piège que ce module existe pour éviter.
 */
const VIEWERS = ['admin', 'direction', 'finance'] as const;

export function canViewOtherUsersEntries(roles: readonly string[] | undefined): boolean {
  return (roles ?? []).some((r) => (VIEWERS as readonly string[]).includes(r));
}

/** Miroir exact de `mayWriteEntry` dans `authz/policies/owned.ts`. */
export function canEditOtherUsersEntries(roles: readonly string[] | undefined): boolean {
  return (roles ?? []).includes('admin');
}
